import { AdsTypeListError } from '../../constants';
import serviceInterceptor from '../../services/ServiceInterceptor';

export const getAdTypesList = async () => {
  try {
    const response = await serviceInterceptor.get('/ad-types');
    if (!response?.data?.success) {
      throw AdsTypeListError;
    }
    return response.data;
  } catch (error) {
    throw AdsTypeListError;
  }
};
